import React, { PureComponent } from 'react';

import Geocoder from '~/core/scripts/components/Geocoder';
import Icon from '~/core/scripts/components/Icon';
import { numberFormat } from '~/core/scripts/utils';
import AreaDisplay from '~/kits/general/AreaDisplay';

class DistanceGeocoder extends PureComponent {

  render() {
    const { area, areas, currentYear } = this.props;
    let firstYear = null;
    let currentData = null;
    let isExtraMarker = false;

    if (area) {
      firstYear = areas.find(d => d.area === area.area.Territorium).data[0].year;
      currentData = areas.find(d => d.area === area.area.Territorium).data.find(d => d.year === 2017);
      isExtraMarker = currentData['Extra-Marker'] !== '';
    }

    return (
      <div className="distance-geocoder">
        <div className="distance-geocoder__title">Wie nah lebt der Wolf heute <em>(2018)</em> bei Ihnen?</div>
        <Geocoder
          onSelect={this.props.onSelect}
          onClear={this.props.onClear}
          setValue={this.props.setValue}
          value={this.props.value}
          placeholder="Ihre Stadt eingeben ..."
        />
        {this.props.area && (
          <div className="distance-geocoder__result">
            <button className="btn close" onClick={this.props.onClear}>
              <Icon type="close" />
            </button>

            <div className="distance-geocoder__from">
              <span className="line line-start"></span>
              {this.props.value.__label}
            </div>
            <div className="distance-geocoder__distance">
              <span className="line line-mid"></span>
              {numberFormat(area.minDistance, 0)} km
            </div>
            <span className="line line-end"></span>
            <AreaDisplay
              area={area.area}
              firstYear={firstYear}
              currentYear={currentYear}
              isExtraMarker={isExtraMarker}
            />
          </div>
        )}
      </div>
    );
  }
}

export default DistanceGeocoder;